import { DISPLAY_TRACKING_USER_INFO, UPDATE_TRACKING_USER_INFO } from '../../../types/conversations/plugins'
import { apiConversation } from 'api'

/**
 * Display tracking info container
 * @param {String} userId
 * @param {Boolean} isOpen
 * @param {Boolean} [isLoading=false]
 */
const displayTrackingUserInfo = (userId, isOpen, isLoading = false) => {
  return {
    type: DISPLAY_TRACKING_USER_INFO,
    isOpen,
    userId,
    isLoading,
  }
}

/**
 * Update user tracking history
 * @param {String} userId
 * @param {Array} [trackingInfo={}]
 */
const updateTrackingUserInfo = (userId, trackingInfo = {}, isEmpty = false) => {
  return {
    type: UPDATE_TRACKING_USER_INFO,
    userId,
    trackingInfo,
    isEmpty,
  }
}

/**
 * Close collapse for user info plugin
 */
const close = () => async (dispatch, getStore) => {
  const { activeUser } = getStore().tabs
  dispatch(displayTrackingUserInfo(activeUser, false))
}

/**
 * Open collapse for user info plugin
 */
const open = () => async (dispatch, getStore) => {
  const { activeUser } = getStore().tabs
  dispatch(displayTrackingUserInfo(activeUser, true))
}

/**
 * Get user tracking history
 */
const get = (userId = null) => async (dispatch, getStore) => {
  let conversationId = userId
  const { activeUser } = getStore().tabs
  const { conversations } = getStore()
  const currentConversation = conversations[activeUser]
  if (!conversationId) {
    conversationId = currentConversation?.user?._id
    if (!conversationId) {
      return
    }
  }
  dispatch(displayTrackingUserInfo(activeUser, true, true))
  try {
    const trackingInfo = {
      user: {
        visits: 0,
        name: '',
        phone: '',
        email: '',
      },
      browsing: {
        ip: '',
        location: '',
        device: '',
        osInfo: '',
        browser: '',
      },
      variables: []
    }
    const { data } = await apiConversation.plugins.trackingUserInfo({ conversationId })
    if (Object.keys(data).length === 0) {
      dispatch(updateTrackingUserInfo(activeUser, trackingInfo, true))
      return
    }
    trackingInfo.user.visits = data?.website?.total || 0
    trackingInfo.user.name = data?.userInfo?.name || ''
    trackingInfo.user.phone = data?.userInfo?.phone || ''
    trackingInfo.user.email = data?.userInfo?.email || ''
    trackingInfo.browsing.ip = data?.userInfo?.ip || ''
    trackingInfo.browsing.location = data?.userInfo?.location || ''
    trackingInfo.browsing.device = data?.userInfo?.device || ''
    trackingInfo.browsing.osInfo = data?.userInfo?.osInfo || ''
    trackingInfo.browsing.browser = data?.userInfo?.browser || ''
    trackingInfo.variables = data?.variables || []
    dispatch(updateTrackingUserInfo(activeUser, trackingInfo))
  } catch (error) {
    console.error('error: ', error)
  }
}


export default {
  close,
  open,
  get,
}
